import { render, staticRenderFns } from "./Multilobby.vue?vue&type=template&id=3c24d958&scoped=true"
import script from "./Multilobby.vue?vue&type=script&lang=js"
export * from "./Multilobby.vue?vue&type=script&lang=js"
import style0 from "./Multilobby.vue?vue&type=style&index=0&id=3c24d958&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24d958",
  null
  
)

export default component.exports